import React from 'react';
import PropTypes from 'prop-types';

import container from 'containers/NetworkMembershipContainer';
import GolfClubCourseList from 'components/shared/ui/courses/GolfClubCourseList';
import GolfClubLogo from 'components/shared/ui/GolfClubLogo';
import SkeletonLine from 'components/shared/skeletons/SkeletonLine';

import { NETWORK_PARTICIPATING_COURSES } from 'utils/routes';
import { M } from 'utils/siteStyle';
import DateHelper from 'utils/dateHelper';

const GolfClubCourses = ({
  golfClubBanner,
  isFetchingGolfClubCoursesDone,
  redirectToNetworkMembership,
  trackGAEvent,
}) => {
  const GolfClubLabel = (M.SG && 'Supreme Golf') || (M.BT && 'Golf Time');

  const handleCourseClick = (course) => {
    const params = {};
    params.course_name = course.name;
    params.course_slug = course.slug;
    params.course_zip_code = course.addressZipcode;
    params.date = DateHelper.formatDate(new Date());
    trackGAEvent({
      name: 'membership_carousel_course_clicked',
      label: 'membership carousel course clicked',
      category: 'membership-carousel-event',
    }, params);
  };

  const renderJoinActions = (
    <div className="mt-6 space-y-6 px-4 md:px-10 lg:px-0">
      <a
        href={NETWORK_PARTICIPATING_COURSES}
        className="font-primary font-bold text-4 leading-6 text-membership-blue underline"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackGAEvent({
            name: 'view_network_courses',
            label: 'View network Courses',
            category: 'membership-courses-event',
          });
        }}
      >
        Discover more exclusive deals
      </a>
      <button
        type="button"
        className="w-full h-12 flex justify-center items-center font-primary-two text-4 leading-5 -tracking-0.2 text-white bg-dark rounded-2 focus:outline-none lg:px-5 lg:w-fit lg:h-10 lg:rounded"
        onClick={() => {
          trackGAEvent({
            name: 'join_now_clicked',
            label: 'Join network membership',
            category: 'membership-courses-event',
          });
          redirectToNetworkMembership();
        }}
      >
        Join now
      </button>
    </div>
  );

  return (
    <section className="mt-12 lg:mt-16 lg:px-14 lg:flex lg:justify-center">
      <div className="w-full max-w-300 lg:flex" style={{ gap: '72px' }}>
        <div className="px-4 md:px-10 lg:px-0 lg:max-w-68" style={{ minWidth: '272px' }}>
          <GolfClubLogo className="w-24 h-6 lg:w-fit lg:h-10" />
          {isFetchingGolfClubCoursesDone ? (
            <h3 className="mt-4 font-primary font-semibold text-6 leading-6 -tracking-0.2 text-dark lg:mt-6 lg:text-8 lg:leading-9 lg:-tracking-0.3">
              {golfClubBanner?.bannerTitle ? golfClubBanner.bannerTitle : 'Secure the best offers.'}
            </h3>
          ) : <SkeletonLine className="mt-4 h-8 lg:mt-6 lg:h-9" />}
          <p className="mt-1 font-primary-two text-3.5 leading-5 -tracking-0.2 text-dark lg:mt-4 lg:text-4 lg:leading-5">
            {`Unlock exclusive deals, perks, and more when you join the ${GolfClubLabel} Club.`}
          </p>
          <div className="hidden lg:block">
            {renderJoinActions}
          </div>
        </div>
        <GolfClubCourseList wrapperStyles="mt-4" handleCourseClick={handleCourseClick} showBadge={{ discount: true }} />
        <div className="lg:hidden">
          {renderJoinActions}
        </div>
      </div>
    </section>
  );
};

GolfClubCourses.defaultProps = {
  golfClubBanner: null,
};

GolfClubCourses.propTypes = {
  golfClubBanner: PropTypes.shape({
    bannerTitle: PropTypes.string,
  }),
  redirectToNetworkMembership: PropTypes.func.isRequired,
  isFetchingGolfClubCoursesDone: PropTypes.bool.isRequired,
  trackGAEvent: PropTypes.func.isRequired,
};
export default container(GolfClubCourses);
